import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: 720,
    margin: '0 auto',
    textAlign: 'center',
    position: 'relative',
    height: '100%',
    marginBottom: theme.spacing(30),
    ...reskinStyles(theme, { gap: theme.spacing(2) })
  },
  row: {
    display: 'flex',
    position: 'relative',
    width: '100%',
    justifyContent: 'center'
  },
  // Layout shim around the core Banner (built for full-width page headers: 50px icon, text block at
  // 94% width, 58px min-height) so icon + text share one row inside the 720px form column. Same
  // approach as permissions-modal.styles.js `bannerWrapper`.
  screenPopBannerWrapper: {
    '& > div': {
      borderRadius: theme.sizes.roundCorners,
      minHeight: 'unset',
      padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
      boxShadow: 'none',
      animation: 'none'
    },
    '& img': {
      width: 24,
      height: 24,
      marginRight: theme.spacing(3)
    },
    '& img + div': {
      width: 'auto',
      flex: 1,
      minHeight: 'unset'
    }
  },
  screenPopBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    width: '100%',
    textAlign: 'left'
  },
  floatingButton: {
    position: 'absolute',
    width: 140,
    fontWeight: 600,
    fontSize: 14,
    right: 0,
    top: theme.spacing(1.5)
  },
  withRejections: ({ rejections, blocks }) => ({
    marginBottom: theme.spacing(72 + rejections * 10 + blocks * 10)
  }),
  title: {
    justifyContent: 'center',
    marginBottom: theme.spacing(10)
  },
  submit: {
    width: 260,
    fontWeight: 600,
    fontSize: 16
  },
  fieldset: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    border: 0,
    padding: 0,
    margin: 0,
    minWidth: 0,
    ...reskinStyles(theme, { gap: theme.spacing(2) })
  },
  submittingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // above the form fields, below the floating footer (zIndex 99) so its spinner button stays visible
    zIndex: 10,
    cursor: 'wait',
    backgroundColor: theme.colorPalette.beige_50_op_50,
    ...reskinStyles(theme, { backgroundColor: 'transparent' })
  },
  warning: {
    justifyContent: 'center',
    textAlign: 'center',
    paddingTop: theme.spacing(5)
  }
});

export default makeStyles(styles);
